'use client';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams } from 'next/navigation';
import { useState, useEffect, useRef } from 'react';

import { getCpPornAlbumVideoList } from '@/api/couple/cpInfo';
import CpAlbumCard from '@/components/cp/cpAlbumCard/cpAlbumCard';
import CpMediaListCard from '@/components/cp/cpMediaListCard/cpMediaListCard';
import { InfiniteScroll } from '@/components/infiniteScroll/infiniteScroll';
import { slickOption } from '@/components/slick/slick';
import { CpPornAlbumInfo, CpPornAlbumVideoList, DetailInfo } from '@/types/cpType';

import CloseIcon from './img/close.svg';

import style from './albumVideoList.module.scss';

type ParamsType = {
    userId: string;
    albumId: string;
};

function AlbumVideoList({
    infoData,
    listData,
    setListData,
    onClose,
    switchDetail
}: {
    infoData: CpPornAlbumInfo;
    listData: CpPornAlbumVideoList[];
    setListData: (list: CpPornAlbumVideoList[]) => void;
    onClose: () => void;
    switchDetail: (params: DetailInfo) => void;
}) {
    const params: ParamsType = useParams();
    const [secondRender, setSecondRender] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const page = useRef(1);
    const isLoading = useRef(false);
    useEffect(() => {
        setSecondRender(true);
    }, []);

    const handleloadMore = async () => {
        if (!secondRender || isLoading.current) return;

        isLoading.current = true;
        page.current += 1;
        const res = await getCpPornAlbumVideoList({
            userId: params.userId,
            albumId: infoData.id,
            page: page.current,
            limit: 6
        });
        if (res.status === 200 && res.data.length > 0) {
            setListData([...listData, ...res.data]);
            if (res.data.length < 6) {
                setIsEnd(true);
            }
        } else {
            setIsEnd(true);
        }

        slickOption?.cpInfoResetHeight();
        isLoading.current = false;
    };

    const changeURL = (url: string) => {
        window.history.pushState({}, '', url);
    };

    const handleClose = () => {
        setIsEnd(false);
        page.current = 1;
        onClose();
    };

    return (
        <div className={style.albumVideoList}>
            <div className={style.header}>
                <div className={style.placeholder} />
                <div className={style.text}>集數</div>
                <CloseIcon onClick={handleClose} />
            </div>
            <div className={style.infoTopBar}>
                <CpAlbumCard album={infoData} />
            </div>
            <div className={style.videoList}>
                {listData.length > 0 || infoData.trailer ? (
                    <>
                        {infoData.trailer && (
                            <CpMediaListCard
                                isVideo
                                isPorn
                                isTrailer
                                className={style.albumVideo}
                                key={`${infoData.trailer.id}`}
                                mediaData={infoData.trailer}
                                onClick={() => {
                                    switchDetail({
                                        isOpen: true,
                                        userId: params.userId,
                                        detailId: infoData.id,
                                        trailerId: infoData.trailer.id,
                                        type: 'trailer'
                                    });
                                    changeURL(
                                        `/cp/${params.userId}/p/${infoData.id}/t/${infoData.trailer.id}`
                                    );
                                    onClose();
                                }}
                            />
                        )}
                        {listData.map((videoData, index) => (
                            <CpMediaListCard
                                isVideo
                                isPorn
                                className={style.albumVideo}
                                key={`${videoData.id}_${index}`}
                                mediaData={videoData}
                                onClick={() => {
                                    switchDetail({
                                        isOpen: true,
                                        userId: params.userId,
                                        detailId: infoData.id,
                                        episodeId: videoData.id,
                                        type: 'episode'
                                    });
                                    changeURL(
                                        `/cp/${params.userId}/p/${infoData.id}/e/${videoData.id}`
                                    );
                                    onClose();
                                }}
                            />
                        ))}
                        <div className={style.endBar}>
                            {isEnd ? (
                                <div className={style.listEnd}>
                                    {listData.length > 0 && '已經到底嘍…'}
                                </div>
                            ) : (
                                <InfiniteScroll onVisible={handleloadMore}>
                                    <div className={style.loadMore}>
                                        <CircularProgress size={24} sx={{ color: '#e52027' }} />
                                    </div>
                                </InfiniteScroll>
                            )}
                        </div>
                    </>
                ) : (
                    <div className={style.noData}>
                        <div className={style.title}>即將上映</div>
                        <div className={style.description}>
                            一部迷片，兩億噴發，三觀刷新，敬請期待！
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AlbumVideoList;
